import { RouteType } from "types/RouteType";
import executiveRoute from "./Executive/executive.Route";
import plantOpsRoute from "./PlantOps/plantOps.Route";
import salesTargetsRoute from "./SalesTargets/salesTargets.Route";

/**
 * The two management dashboards promised to Jim by email on 2026-08-29 —
 * see meetings/2026-08-29_management-dashboards/.
 */
const dashboardsRoutesList: RouteType[] = [
  executiveRoute,
  plantOpsRoute,
  salesTargetsRoute,
];

export default dashboardsRoutesList;
